import { mapEnumToOptions } from '@abp/ng.core';

export enum DiscountTypes {
  DollarAmount = 1,
  Percentage = 2,
}

export const discountTypesOptions = mapEnumToOptions(DiscountTypes);
